import { API_ENDPOINTS } from "../../constants";
import {
  uploadFile,
  postForFileAsResponse,
  getForFileAsResponse,
} from "../../api/index";

const { APIS } = API_ENDPOINTS;
/*
========================================
   Quotes Document Details Functions
========================================
*/

const uploadRawQuoteDocument = filevalue =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", filevalue);

    uploadFile(`${APIS.UPLOAD_QUOTE_DOCUMENT}`, formData)
      .then(res => {
        if (!res.Components) {
          reject(Error("Excepted a key `Components` in response"));
        }
        resolve(res.Components);
      })
      .catch(error => {
        reject(error);
      });
  });

const exportFillablePDF = docId =>
  new Promise((resolve, reject) => {
    postForFileAsResponse(`${APIS.EXPORT_FILLED_PDF}/${docId}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const uploadRevisedDocument = (fileDetails, name, docNo) =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("doc", fileDetails);
    formData.append("opp_name", name);
    formData.append("doc_no", docNo);
    uploadFile(`${APIS.UPLOAD_REVISED_DOCUMENT}`, formData)
      .then(res => {
        if (!res.Document) {
          reject(Error("Excepted a key `Document` in response"));
        }
        resolve(res.Document);
      })
      .catch(error => {
        reject(error);
      });
  });

const getDocInPdf = docId =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(`${APIS.FETCH_DOC_SIGN_PDF}/${docId}/signed`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const downloadSSRPdf = (docId, event) =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(
      `${APIS.FETCH_SSR_DOC_SIGN_PDF}/pdf/${docId}?event=${event}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const downloadTemaplteSSRPdf = templateID =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(`${APIS.FETCH_SSR_TEMPLATE_PDF}/pdf/${templateID}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export {
  uploadRawQuoteDocument,
  uploadRevisedDocument,
  getDocInPdf,
  exportFillablePDF,
  downloadSSRPdf,
  downloadTemaplteSSRPdf,
};
